import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.132 3.596c0-.022.003-.034.005-.04a.189.189 0 01.07-.011h6.683a.188.188 0 01.07.012.123.123 0 01.005.039v6.475a.124.124 0 01-.005.039h-.003l-.003.002a.19.19 0 01-.064.009H6.132V3.596zm.074-1.117c-.297 0-.588.097-.81.309a1.103 1.103 0 00-.33.808v7.591H12.89c.297 0 .59-.096.81-.309.223-.214.331-.504.331-.807V3.596c0-.303-.108-.594-.33-.808a1.154 1.154 0 00-.81-.309H6.205zM3.701 4.82v7.634h7.974v1.066h-9.04v-8.7H3.7z",
    fill: "#000",
    fillOpacity: 0.54
  }));
}
export default SvgComponent;